import React from "react";

const SearchSVG = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#888"
    strokeWidth="2"
  >
    <circle cx="11" cy="11" r="7" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const SearchBar = ({ value, onChange }) => (
  <div className="relative w-full flex-grow flex items-center h-12 px-4 bg-white border border-gray-200 rounded-xl">
    <span className="absolute left-4 z-10 flex items-center">
      <SearchSVG />
    </span>
    <input
      type="text"
      placeholder="Search by Name, Job Title, Keywords or Business"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="w-full pl-10 text-sm font-semibold text-gray-600 placeholder-gray-400 focus:outline-none bg-transparent"
    />
  </div>
);

export default SearchBar;
